import type { IconSvgObject } from './types';

const Ticket01Icon: IconSvgObject = [
  ["path", { d: "M2 9.5V6C2 4.89543 2.89543 4 4 4H20C21.1046 4 22 4.89543 22 6V9.5C20.6193 9.5 19.5 10.6193 19.5 12C19.5 13.3807 20.6193 14.5 22 14.5V18C22 19.1046 21.1046 20 20 20H4C2.89543 20 2 19.1046 2 18V14.5C3.38071 14.5 4.5 13.3807 4.5 12C4.5 10.6193 3.38071 9.5 2 9.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9 4L9 20", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Ticket01Icon;
